export function retryWithDelay(
  attemptFn: (args?: unknown) => Promise<unknown>,
  failAttemptFn: (args?: unknown) => void,
  maxAttempt = 10,
  timeout = 3000,
) {
  let attempts = 0;
  async function execute() {
    const isSuccess = await attemptFn();
    attempts++;
    if (!isSuccess) {
      if (maxAttempt && attempts >= maxAttempt) {
        if (typeof failAttemptFn === 'function') {
          failAttemptFn();
        }
      } else {
        setTimeout(execute, timeout);
      }
    }
  }
  return execute();
}
